export function focusOnFirstInvalidLsqInput(): void {
    const inputInsideInvalidLsqInput = document.querySelector(
        'lsq-input.ng-invalid input'
    ) as HTMLInputElement;
    if (inputInsideInvalidLsqInput) {
        inputInsideInvalidLsqInput.focus();
    }
}
